import { render } from "./accountM.vue?vue&type=template&id=5b9633ea"
import script from "./accountM.vue?vue&type=script&lang=js"
export * from "./accountM.vue?vue&type=script&lang=js"

import "./accountM.vue?vue&type=style&index=0&id=5b9633ea&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__